import {createAction} from "@reduxjs/toolkit";

export const reportClientError = createAction('telemetry/reportError');
